import toast from "react-hot-toast";
import * as api from "../Api/index";
import { errorMessage, loadFailed } from "../utils/errorMessage";

export const getNewUnapprovedAsset = () => async (dispatch) => {
  try {
    const { data } = await api.getNewAssets();
    dispatch({ type: "GET_NEW_UNAPPROVED_ASSETS", payload: data });
  } catch (error) {
    loadFailed(error);
  }
};
export const updateCompanyAsset = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving changes...");
    const { data } = await api.updateAsset(id, postData);
    dispatch({ type: "APPROVE_NEW_ASSET", payload: id });
    toast.remove(updatingId);
    toast.success("Changes saved successfully");
    return data;
  } catch (error) {
    toast.remove(updatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};
export const updateManyCompanyAsset = (id, postData) => async (dispatch) => {
  try {
    const { data } = await api.updateAsset(id, postData);
    dispatch({ type: "APPROVE_NEW_MANY_ASSET", payload: id });
    return data;
  } catch (error) {
    throw error;
  }
};
export const updateCompanyAssetReturn = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving changes...");
    const { data } = await api.updateAsset(id, postData);
    dispatch({ type: "UPDATE_NEW_ASSET", payload: data });
    toast.remove(updatingId);
    toast.success("Changes saved successfully");
    return data;
  } catch (error) {
    toast.remove(updatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};

export const deleteNewAsset = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting asset...");
    const res = await api.deleteNewAsset(id);
    dispatch({ type: "DELETE_NEW_ASSET", payload: id });
    toast.remove(deletingId);
    toast.success("Asset Successfully deleted");
    return res;
  } catch (error) {
    toast.remove(deletingId);
    toast.error(errorMessage(error));
    throw error;
  }
};
export const deleteBulkNewAsset = (id) => async (dispatch) => {
  try {
    const res = await api.deleteNewAsset(id);
    dispatch({ type: "DELETE_NEW_BULK_ASSET", payload: id });
    return res;
  } catch (error) {
    throw error;
  }
};

export const createNewAsset = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting asset for approval....");
    const { data } = await api.createAsset(postData);
    dispatch({ type: "CREATE_NEW_ASSET", payload: data });
    toast.remove(creatingId);
    toast.success("Successfully submitted");
    return data;
  } catch (error) {
    toast.remove(creatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};

export const createBulkAsset = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting asset for approval....");
    const { data } = await api.createBulkAsset(postData);
    dispatch({ type: "CREATE_NEW_BULK_ASSET", payload: data });
    toast.remove(creatingId);
    toast.success("Successfully submitted");
    return data;
  } catch (error) {
    toast.remove(creatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};

export const uploadExcelAssets = (postData) => async (dispatch) => {
  try {
    const { data } = await api.createExcelAsset(postData);

    dispatch({
      type: "UPLOAD_EXCEL_ASSETS",
      payload: data,
    });

    toast.success(data.message || "Assets uploaded successfully");

    return data;
  } catch (error) {
    toast.error(
      errorMessage(error, "Failed to upload assets"),
    );

    throw error;
  }
};
